import { createAPI } from '@common'

export default {
  // 新建线索
  // postClues: config => createAPI('customEncryptApiName-1/0w20dmvft', 'post', config, {
  //   e5namespace: 'cluesAdd'
  // }),
  postClues: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/OFXTQMBO;0w20dmvft',
        'post',
        { data: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20dmvft', 'post', { data: config.params }, null)
    }
  },
  // 获取线索
  getClues: (config) => createAPI('customEncryptApiName-1/0w20dmvft', 'get', config),
  // 修改线索
  putClues: (config) =>
    createAPI('customEncryptApiName-1/0w20dmvft', 'put', config, {
      e5namespace: 'cluesAdd'
    }),
  // 通用检索
  postApiFts: (config) => createAPI('customEncryptApiName-1/0bqj0gut', 'post', config),
  // 获取转选题
  getClueToTopic: (config) => createAPI('customEncryptApiName-1/0w20upqjdt0dmvf', 'get', config),
  // 获取base64Image
  getE5Images: (config) =>
    createAPI('customEncryptApiName-1/DNT;0f60jnbhft', 'get', config, {
      hubForward: true,
      hub: 'e5/hub'
    }),
  // 获取分组个数
  getMamGroups: (config) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0w20nbn0hspvqt',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub' }
      )
    } else {
      return createAPI('customEncryptApiName-1/0w20nbn0hspvqt', 'get', { params: config.params }, null)
    }
  }
}
